import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ArrowRight, ShieldCheck } from "lucide-react";

export default function AdminLogin({ onSuccess }) {
  const [key, setKey] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!key.trim()) return;
    setLoading(true);
    try {
      await api.post("/admin/login", { key });
      toast.success("Welcome back");
      onSuccess(key);
    } catch {
      toast.error("Invalid admin key");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-screen w-full flex items-center justify-center bg-background">
      <div
        className="absolute inset-0 opacity-[0.18]"
        style={{
          backgroundImage:
            "linear-gradient(hsl(var(--border)) 1px, transparent 1px), linear-gradient(90deg, hsl(var(--border)) 1px, transparent 1px)",
          backgroundSize: "80px 80px",
        }}
      />
      <div className="relative z-10 w-full max-w-md mx-auto px-6">
        <div className="bg-white border border-foreground">
          <div className="px-8 pt-8 pb-6 border-b border-foreground">
            <div className="flex items-center gap-3 mb-6">
              <ShieldCheck className="w-4 h-4 text-primary" strokeWidth={1.5} />
              <span className="overline">Admin Access</span>
            </div>
            <h1 className="font-display text-4xl tracking-tighter leading-tight font-medium">
              IBA Servicing Admin
            </h1>
            <p className="mt-3 text-sm text-muted-foreground">
              Partner codes, view tracking, and lead capture.
            </p>
          </div>
          <form onSubmit={submit} className="px-8 py-6">
            <label htmlFor="admin-key" className="overline block mb-2">Admin Key</label>
            <div className="flex items-end gap-3">
              <input
                id="admin-key"
                data-testid="admin-key-input"
                type="password"
                autoFocus
                value={key}
                onChange={(e) => setKey(e.target.value)}
                className="input-sharp flex-1"
              />
              <button
                type="submit"
                disabled={loading}
                data-testid="admin-login-submit"
                className="btn-primary disabled:opacity-50"
              >
                {loading ? "…" : "Enter"}
                <ArrowRight className="w-4 h-4" />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
